exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".location-details[data-v-01a6086c] {\n  font-size: .8rem;\n}\n.review-date[data-v-01a6086c] {\n  font-size: .8rem;\n  color: #777;\n  margin-top: .5rem;\n}\n.review__reply[data-v-01a6086c] {\n  border-left: 3px solid #e5e5e5;\n  padding: 5px 0 0 10px;\n}\n.partTags[data-v-01a6086c] {\n  height: 100% !important;\n}\n.recommendation[data-v-01a6086c] {\n  text-transform: capitalize;\n  font-weight: 900;\n}\n.recommendation-positive[data-v-01a6086c] {\n  color: green;\n}\n.recommendation-negative[data-v-01a6086c] {\n  color: red;\n}\n", ""]);

// exports
